module.exports = __webpack_public_path__ + "img/droplet-solid.6095e4e8.svg";